export default "__VITE_ASSET__KxdkR_So__"